var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.061 10.53a3.53 3.53 0 11-7.06 0 3.53 3.53 0 017.06 0zm-.48 4.615a5.53 5.53 0 111.564-1.564L19 17.436 17.436 19l-3.855-3.855z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }